import axios from "axios";

export async function createNewOrder(order) {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/order`, order);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}